<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">{{ $t('Webportal.CX.Margin.FileImport.Title') }}</h4>

          <file-uploader
            :label="$t('Webportal.CX.Margin.FileImport.Description')"
            :value="importFiles"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :upload-url="importFileUploadUrl"
            :show-preview-link="false"
            :show-download-button="false"
            :continue-on-error="true"
            @is-busy-changed="isGeneralFileUploaderBusy = $event"
          />
        </div>

        <div class="card-footer">
          <button type="button" @click="$router.go(-1);" class="btn btn-secondary" :disabled="isGeneralFileUploaderBusy">
            <font-awesome-icon :icon="['far', 'arrow-left']" />
            {{ $t("Webportal.Back") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import FileUploader from "@/components/FileUploader";

export default {
  name: "MarginFileImport",

  components: { FileUploader },

  mixins: [AppConfig ],

  data() {
    return {
      importFiles: [],
      isGeneralFileUploaderBusy: false,
    };
  },

  mounted() {
    this.initializeTheme();
  },

  computed: {
    importFileUploadUrl() {
      return process.env.BASE_URL + `api/marginmanagement/import-file`;
    }
  },
};
</script>
